import { calculateGradientsBubble } from "./gradients_BUBBLE";
import { calculateGradientsLiquid } from "./gradients_LIQUID";
import { calculateGradientsMist } from "./gradients_MIST";
import { calculateGradientsSlug } from "./gradients_SLUG";
import { calculateGradientsTransition } from "./gradients_TRANSITION";
import type { PipeFrictionContext } from "../d";
import type { PipeFrictionIntermediates } from "..";

export enum OrkiszewskiFlowRegime {
  BUBBLE = "Bubble",
  SLUG = "Slug",
  MIST = "Mist",
  TRANSITION = "Transition",
  LIQUID = "Liquid"
}

export type OrkiszewiskiGradients = {
  flowRegime: OrkiszewskiFlowRegime;
  frictionPressurePSIA: number;
  intermediates: {
    [key: string]: unknown;
  };
};

export function getOrkiszewiskiFrictionProperties(
  context: PipeFrictionContext
): PipeFrictionIntermediates {
  const {
    fluidPropertiesContext: {
      fluidFrictionProperties: { flowRegime }
    }
  } = context;

  let intermediates;
  if (flowRegime === OrkiszewskiFlowRegime.LIQUID) {
    intermediates = calculateGradientsLiquid(context);
  } else if (flowRegime === OrkiszewskiFlowRegime.BUBBLE) {
    intermediates = calculateGradientsBubble(context);
  } else if (flowRegime === OrkiszewskiFlowRegime.SLUG) {
    intermediates = calculateGradientsSlug(context);
  } else if (flowRegime === OrkiszewskiFlowRegime.MIST) {
    intermediates = calculateGradientsMist(context);
  } else if (flowRegime === OrkiszewskiFlowRegime.TRANSITION) {
    const mistIntermediates = calculateGradientsMist(context);
    const transitionIntermediates = calculateGradientsTransition(
      context,
      mistIntermediates.frictionGradient as number,
      mistIntermediates.staticGradient as number
    );
    // Override transition with mist aside from flowRegime and totalGradient
    intermediates = {
      ...transitionIntermediates,
      ...mistIntermediates
    };
    intermediates.flowRegime = OrkiszewskiFlowRegime.TRANSITION;
  } else {
    // If we reach this point, the flow regime is not recognized, or orkiszewiski
    // does not have a specific calculation for it, so we use liquid.
    intermediates = calculateGradientsLiquid(context);
  }

  const frictionProperties: PipeFrictionIntermediates = {
    ...intermediates
  };

  return {
    ...frictionProperties,
    flowRegime
  };
}
